import React, { useState } from 'react'
import { Redirect, useHistory, useParams } from 'react-router-dom'

import { withErrorBoundary } from 'config/withErrorBoundary/withErrorBoundary'
import { FiltersContextController } from 'context/filters/filtersContextController/FiltersContextController'
import { useViewTracking } from 'hooks/useViewTracking'
import { useVersion } from 'hooks/useVersion'
import { useUserInformation } from 'hooks/useUserInformation'
import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'

import { FilterPane } from './FilterPane'
import { Data } from './Data'
import { DiversityParams } from './diversity.types'
import * as S from './diversity.styles'

type SelectedFilter = string | SelectedFilters

export type SelectedFilters =
    | undefined
    | {
          [key: string]: SelectedFilter
      }

const DiversityWithoutEB = () => {
    useViewTracking('Analyze v2 - Diversity')

    const versionsContext = useVersion()
    const { enableDebugMode } = useUserInformation()

    const [showProfilesPage, setShowProfilesPage] = useState(false)

    const { tab } = useParams<DiversityParams>()
    const [selectedTab, setSelectedTab] = useState<string>(tab)
    const history = useHistory()

    const onTabChange = (to: string) => {
        setSelectedTab(to)

        if (tab !== to) {
            return history.replace(`/analyze2/diversity/${to}${location.search}`)
        }
    }

    const isV2Enabled = versionsContext?.version === versionsContext?.AVAILABLE_VERSIONS.v2

    if (!isV2Enabled && !enableDebugMode) {
        return <Redirect to={generateCompanyURI('/analyze/diversity')} />
    }

    return (
        <FiltersContextController>
            <S.Diversity>
                <S.LeftBox>
                    <FilterPane
                        handleShowProfilesPage={(isProfilesVisible) => setShowProfilesPage(isProfilesVisible)}
                        selectedTab={selectedTab}
                        handleOnTabChange={onTabChange}
                    />
                </S.LeftBox>

                <S.RightBox>
                    <Data showProfilesPage={showProfilesPage} selectedTab={tab} />
                </S.RightBox>
            </S.Diversity>
        </FiltersContextController>
    )
}

export const Diversity = withErrorBoundary(DiversityWithoutEB, {})
